import {
    ColorValueRestDto, OverlayAnimationRestDto, OverlayPositionRestDto, OverlayRestDto, PaddingRestDto
} from "@/api/pharma-cms-content-block/models";
import {BackgroundColorEnum} from "@/api/enums/background-color-enum";
import {ObjectVerticalPositionEnum} from "@/api/enums/object-vertical-position-enum";
import {OverlayBlendModeEnum} from "@/api/enums/overlay-blend-mode-enum";
import {ColorValueRestDtoModel} from "@/models/api/ColorValueRestDtoModel";
import {OverlayPositionRestDtoModel} from "@/models/api/pharma-cms-content-page/OverlayPositionRestDtoModel";
import {PaddingRestDtoModel} from "@/models/api/pharma-cms-content-page/PaddingRestDtoModel";
import {OverlayAnimationRestDtoModel} from "@/models/api/pharma-cms-content-block/OverlayAnimationRestDtoModel";

// The position and padding DTOs of the content-block package are structurally
// identical to the content-page ones, so their existing models are reused.
export class OverlayRestDtoModel implements OverlayRestDto {
    color: ColorValueRestDto;               // required
    text?: string | null;
    position: OverlayPositionRestDto;        // required
    padding?: PaddingRestDto | null;
    content_vertical_position_code?: ObjectVerticalPositionEnum | null;
    animation?: OverlayAnimationRestDto | null;
    blend_mode_code?: OverlayBlendModeEnum | null;
    sort_weight?: number | null;

    constructor(color: ColorValueRestDto, position: OverlayPositionRestDto) {
        this.color = color;
        this.position = position;
    }

    static createWithDefaults(): OverlayRestDtoModel {
        // color is required by the API: an empty color value is rejected. Transparent
        // is the neutral choice — the overlay is there but paints nothing yet.
        const defaultColor = ColorValueRestDtoModel.createWithDefaults();
        defaultColor.color_code = BackgroundColorEnum.TRANSPARENT;

        return new this(
            defaultColor,
            OverlayPositionRestDtoModel.createWithDefaults(),
        );
    }

    static cloneFrom(source: OverlayRestDto): OverlayRestDtoModel {
        const clone: OverlayRestDtoModel = new this(
            ColorValueRestDtoModel.cloneFrom(source.color),
            OverlayPositionRestDtoModel.cloneFrom(source.position),
        );
        clone.text = source.text ?? null;
        clone.padding = source.padding ? PaddingRestDtoModel.cloneFrom(source.padding) : null;
        clone.content_vertical_position_code = source.content_vertical_position_code ?? null;
        clone.animation = source.animation ? OverlayAnimationRestDtoModel.cloneFrom(source.animation) : null;
        clone.blend_mode_code = source.blend_mode_code ?? null;
        clone.sort_weight = source.sort_weight ?? null;

        return clone;
    }
}
